import Api from '@/js/services/contracts/ApiContracts';
import { acceptHMRUpdate, defineStore } from 'pinia';

export const useGisStore = defineStore('gis', {
  state: () => ({
    /* TODO: This seems to be not used
    osm: {
      route: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      type: 'OSM',
      properties: {
        maxZoom: 19,
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
      },
    },
    */
    googleHybrid: {
      route: 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}?apikey=AIzaSyAlUKxY4pMzMwUK7OQ9N737Zj0TbLcW6TA',
      type: 'Google',
      properties: {
        maxZoom: 19,
        subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      },
    },
    currentLayersMap: [],
    currentOverlayLayer: '',
    currentIndexes: {},
    currentGraphicLayer: {},
    currentInitIntervalDates: {},
    currentEndIntervalDates: {},
    datesList: [],
    featureInfo: {},
    currentGeojsonFeature: {},
    histogram: null,
    timelineIndexes: null,
  }),

  actions: {
    addCurrentLayersMap(value) {
      for (const layerMap of this.currentLayersMap) {
        if (layerMap === value) {
          return;
        }
      }
      this.currentLayersMap.push(value);
    },

    removeCurrentLayersMap(value) {
      const newCurrentLayersMap = [];
      for (const currentLayersMap of this.currentLayersMap) {
        if (currentLayersMap !== value) {
          newCurrentLayersMap.push(currentLayersMap);
        }
      }
      this.currentLayersMap = newCurrentLayersMap;
    },

    async fetchGraphicLayer({ currentOverlayLayer, key }) {
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };
        const url = `${Api.getGeoServer()}/get_raster_stats/?layer=${currentOverlayLayer}&dates=${this.currentInitIntervalDates},${this.currentEndIntervalDates}&index=${this.currentIndexes[key].toLowerCase()}`;

        await fetch(url, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            this.currentGraphicLayer = JSON.parse(result);
          })
          .catch((error) => Promise.reject(error));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error); // Esta llamada no tiene los mensajes de error normalizados
      }
    },

    async fetchDatesLayer(layer) {
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };
        const url = `${Api.getGeoServerRasterDates()}?layer=${layer}&server=gis.hispatecanalytics.com&ws=timacagro`;

        await fetch(url, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            this.datesList = JSON.parse(result);
          })
          .catch((error) => Promise.reject(error));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error); // Esta llamada no tiene los mensajes de error normalizados
      }
    },

    async fetchFeatureInfo({ queryParams }) {
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };
        const url = `${Api.getGeoServerPort()}/${queryParams}`;

        await fetch(url, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            this.featureInfo = JSON.parse(result);
          })
          .catch((error) => Promise.reject(error));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error); // Esta llamada no tiene los mensajes de error normalizados
      }
    },

    async fetchCurrentGeojsonFeature(url) {
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };

        await fetch(url, requestOptions)
          .then((response) => response.json())
          .then((result) => {
            this.currentGeojsonFeature = result;
          })
          .catch((error) => Promise.reject(error));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error); // Esta llamada no tiene los mensajes de error normalizados
      }
    },

    async fetchHistogram({ layer, date, index }) {
      try {
        const requestOptions = {
          method: 'GET',
          redirect: 'follow',
        };
        const url = `${Api.getGeoServerTemperatureHistogram()}?layer=${layer}&dates=${date}&index=${index}`;

        await fetch(url, requestOptions)
          .then((response) => response.text())
          .then((result) => {
            this.histogram = JSON.parse(result);
          })
          .catch((error) => Promise.reject(error));
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    async fetchTimelineIndexes({
      location,
      initDate,
      endDate,
      index,
      companyId,
    }) {
      try {
        const xhr = await Api.fetchTimelineIndexes(location, initDate, endDate, index, companyId);
        this.timelineIndexes = JSON.parse(xhr.response).data;
        return Promise.resolve();
      } catch (error) {
        // Si el error es no controlado, no estará en formato json y por tanto,
        // se devolverá como vino para que se visualice en raw
        try {
          const parsedError = JSON.parse(error.message).code;
          return Promise.reject(parsedError);
        } catch {
          return Promise.reject(error);
        }
      }
    },
  },

  persist: true,
});

if (import.meta.webpackHot) {
  import.meta.webpackHot.accept(acceptHMRUpdate(useGisStore, import.meta.webpackHot));
}
